let audioContext = null;

const getAudioContext = () => {
  if (!audioContext) {
    audioContext = new (window.AudioContext || window.webkitAudioContext)();
  }
  if (audioContext.state === 'suspended') {
    audioContext.resume();
  }
  return audioContext;
};

const playTone = (ctx, frequency, startTime, duration, type = 'sine', gain = 0.3) => {
  const oscillator = ctx.createOscillator();
  const gainNode = ctx.createGain();
  oscillator.type = type;
  oscillator.frequency.setValueAtTime(frequency, startTime);
  gainNode.gain.setValueAtTime(gain, startTime);
  gainNode.gain.exponentialRampToValueAtTime(0.001, startTime + duration);
  oscillator.connect(gainNode);
  gainNode.connect(ctx.destination);
  oscillator.start(startTime);
  oscillator.stop(startTime + duration);
};

const soundPatterns = {
  success: (ctx, now) => {
    playTone(ctx, 523.25, now, 0.15);          // C5
    playTone(ctx, 659.25, now + 0.12, 0.15);  // E5
    playTone(ctx, 783.99, now + 0.24, 0.25);  // G5
  },
  warning: (ctx, now) => {
    playTone(ctx, 440, now, 0.2, 'triangle', 0.35);       // A4
    playTone(ctx, 349.23, now + 0.22, 0.3, 'triangle', 0.35); // F4
  },
  error: (ctx, now) => {
    playTone(ctx, 220, now, 0.15, 'sawtooth', 0.2);      // A3
    playTone(ctx, 185, now + 0.18, 0.35, 'sawtooth', 0.2); // ~G#3
  },
  info: (ctx, now) => {
    playTone(ctx, 587.33, now, 0.2);  // D5
  },
};

const playNotificationSound = (type = 'info') => {
  try {
    const settings = JSON.parse(localStorage.getItem('notificationSettings') || '{}');
    if (settings.alertSoundEnabled === false) return;

    const ctx = getAudioContext();
    const pattern = soundPatterns[type] || soundPatterns.info;
    pattern(ctx, ctx.currentTime);
  } catch {
    // Audio not available — silently ignore
  }
};

export { playNotificationSound };
export default playNotificationSound;